import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Stylesheets
import "./IconButton.scss";

const IconButton = (props) => {
  const { ariaLabel, className, ...rest } = props;

  const classes = classNames("icon_button", className);

  return (
    <button className={classes} aria-label={ariaLabel} {...rest}>
      {props.children}
    </button>
  );
};

IconButton.propTypes = {
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.any,
};

export default IconButton;
